<template>
  <div class="qr">
    <div style="text-align:left; width:100%">
      <el-form ref="form" :model="form" :rules="rules">
        <el-form-item label="药店资质信息" style="position:relative; left: -50px">
          <el-image :src="getStorePic(form.CID)" class="picClerk">
            <div slot="error">
              <el-image
                :lazy="true"
                src="../../../static/error404.png"
                style="width: 380px; height: 240px"
              />
            </div>
          </el-image>
        </el-form-item>
<!--
        <el-form-item label="医师资质信息" style="position:relative; left: -50px">
          <el-image class="picDoc" :src="getDoctorPic(form.doctorID)">
            <div slot="error">
              <el-image
                :lazy="true"
                src="../../../static/error404.png"
                style="width: 380px; height: 240px"
              />
            </div>
          </el-image>
        </el-form-item>
-->
        <el-form-item label="药师资质信息" style="position:relative; left: -50px">
          <el-image class="picPhar" :src="getPharPic(form.pharID)">
            <div slot="error">
              <el-image
                :lazy="true"
                src="../../../static/error404.png"
                style="width: 380px; height: 240px"
              />
            </div>
          </el-image>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>



<script>
import qs from "qs";
export default {
  name: "Login",
  data() {
    return {
      zizhiApi: "https://yc.suyizaixian.com:30005/queryZiZhi",
      //zizhiApi: "https://yc.suyizaixian.com:30005/queryZiZhi",

      form: {
        CID: "error404",
        doctorID: "error404",
        pharID: "error404"
      },
      rules: {}
    };
  },
  props: {
    msg: String
  },
  methods: {
    getStorePic(num) {
      try {
        let pic = require("../../../static/zizhi/" + num + ".png");
        return pic;
      } catch {
        return "../../../static/error404.png";
      }
    },
    getDoctorPic(num) {
      try {
        let pic = require("../../../static/zizhi/" + num + ".png");
        return pic;
      } catch {
        return "../../../static/error404.png";
      }
    },
    getPharPic(num) {
      try {
        let pic = require("../../../static/zizhi/" + num + ".png");
        return pic;
      } catch {
        return "../../../static/error404.png";
      }
    }
  },
  mounted() {
    let recipeIDnum = this.$route.query.id;
    var _this = this;

    if (recipeIDnum) {
      let datas = {
        id: recipeIDnum
      };

      _this.axios
        .post(_this.zizhiApi, qs.stringify(datas))
        .then(response => {
          let res = response.data;
          console.log(res);
          if (res.data.result == "success") {
            _this.form.CID = res.data.CID;
            _this.form.doctorID = res.data.doctorID;
            _this.form.pharID = res.data.pharID;
          } else {
            alert(res.data.err.code);
          }
        })
        .catch(e => {
          alert(e + "图片加载失败");
        });
    } else {
      _this.form.CID = "404";
      _this.form.doctorID = "404";
      _this.form.pharID = "404";
    }
  }
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a {
  color: #42b983;
}
.picClerk{
  max-width: 80%;
}
.picDoc{
    max-width: 80%;
}
.picPhar{
      max-width: 80%;

}
</style>
